import React from "react";

export class Page extends React.Component {
    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="page">
                        {this.props.children}
                    </div>
                </div>
            </div>
        )
    }
}

export class PageHeader extends React.Component {
    render() {
        return (
            <div className="page-header">
                <div className="col-lg-12">
                    {/*this.props.children*/}
                    <span className="page-header-title" dangerouslySetInnerHTML={{ __html: this.props.title }} />
                    <small dangerouslySetInnerHTML={{ __html: this.props.subtitle }} />
                    {this.props.right ? this.props.right() : ""}
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export class PageBody extends React.Component {
    render() {
        return (
            <div className="page-body">
                <div className="col-lg-12">
                    {this.props.children}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/base/Page.jsx